export default __webpack_public_path__ + "static/media/Frame.27474a65.png";